import { Helmet } from 'react-helmet-async';

interface GeoMetaTagsProps {
  latitude?: number;
  longitude?: number;
  placename?: string;
  region?: string;
  country?: string;
}

export const GeoMetaTags = ({ latitude, longitude, placename, region, country = "DE" }: GeoMetaTagsProps) => {
  return (
    <Helmet>
      {latitude && longitude && (
        <>
          <meta name="geo.position" content={`${latitude};${longitude}`} />
          <meta name="ICBM" content={`${latitude}, ${longitude}`} />
        </>
      )}
      {placename && <meta name="geo.placename" content={placename} />}
      {region && <meta name="geo.region" content={`${country}-${region}`} />}
    </Helmet>
  );
};
